<div class="app-container">
  <div class="leads-offers-container">

    <!-- Layout principal -->
    <div class="main-layout" *ngIf="!isLoading && !errorMessage">

      <!-- Coluna esquerda -->
      <div class="left-column">

        <!-- TABELAS -->
        <div class="tables-section" *ngIf="selectedOffer">
          <div *ngIf="getLayoutType() !== 'PA' && getLayoutType() !== 'PR'">
            <div class="table-row">
              <app-info-field
                [data]="infoLinha1"
                [columns]="3">
              </app-info-field>
            </div>
            <div class="spacer" style="height: 2rem;"></div>

            <div class="table-row">
              <app-info-field
                [data]="infoLinha2"
                [columns]="4">
              </app-info-field>
            </div>
            <div class="spacer" style="height: 2rem;"></div>

            <div class="table-row">
              <app-info-field
                [data]="infoLinha3"
                [columns]="4">
              </app-info-field>
            </div>
          </div>
        </div>

      </div>

      <!-- Coluna direita -->
      <div class="right-column">
        <div class="card-wrapper">
          <app-offer-info
            *ngIf="selectedOffer"
            [carTitle]="selectedOffer.title"
            [carImage]="selectedOffer.imageUrl"
            [carInfos]="selectedOffer.carInfos"
            [selectedOffer]="selectedOffer"
            [leadId]="leadId"
            [currentOfferText]="currentOfferText"
            [isLoadingText]="isLoadingText"
            (sendAmigavel)="onSendAmigavel()"
            (sendFormal)="onSendFormal()"
            (sendPersuasiva)="onSendPersuasiva()"
            (sendServicosFinanceiros)="onSendServicosFinanceiros()"
            (sendOfferEmail)="onSendEmail($event)"
            (sendOfferWhatsapp)="onSendWhatsapp($event)">
          </app-offer-info>
        </div>
      </div>

    </div>

    <!-- Estados -->
    <div *ngIf="isLoading" class="loading-state">
      Carregando...
    </div>

    <div *ngIf="errorMessage && !isLoading" class="error-state">
      {{ errorMessage }}
    </div>

  </div>

  <!-- BOTÕES NOVOS - APENAS ESTA DIV É NOVA (fora do container principal) -->
  <div class="right-nav-buttons">
    <button class="nav-btn" (click)="navigateToPage(0)">Informações Gerais</button>
    <button class="nav-btn" (click)="navigateToPage(2)">Histórico</button>
  </div>
</div>
